import React from 'react';
import { IoMdHelp } from 'react-icons/io';
import { IconButton } from '@miroculus/nucleo';
const HelpButton = (props) => (React.createElement(IconButton, { label: "Help", ...props },
    React.createElement(IoMdHelp, { size: "1.5em" })));
export default HelpButton;
